import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import styles from './onboardingSuggestionsStyles';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const onboardingSuggestions = ({
  title,
  suggestions,
  cardComponent: Card,
  loading,
  refetch,
  cardLimit = 10,
  filterList = [],
  filterFunction,
  categoryType,
  className = ''
}) => {
  const filterSet = new Set(filterList);
  let filteredSuggestions = [];
  if (suggestions && filterFunction) {
    suggestions.forEach(suggestion => {
      if (!filterSet.has(filterFunction(suggestion))) {
        filteredSuggestions.push(suggestion);
      }
    });
    filteredSuggestions = filteredSuggestions.slice(0, cardLimit);
  } else {
    filteredSuggestions = suggestions;
  }

  return (
    <div>
      <h3 className={styles.fieldHeader}>{title}</h3>
      {(loading && <LoadingSpinner type="secondary" />) || (
        <div>
          <TransitionGroup className={`${styles.suggestionCardArea} ${className}`}>
            {filteredSuggestions.map(suggestion => (
              <CSSTransition key={suggestion.id + categoryType} classNames="fade" timeout={1000}>
                <Card {...suggestion} refetch={refetch} />
              </CSSTransition>
            ))}
          </TransitionGroup>
        </div>
      )}
    </div>
  );
};

export default onboardingSuggestions;
